import * as React from "react";
import { connect } from "react-redux";
import { Container, Dropdown, Accordion, Card, Button, Form, Spinner, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import { CustomerService } from "../../Common/Services/CustomerService";
import  CustomerMasterSlidout  from "../../Modules/Masters/CustomerMasterSlidout";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
const { SearchBar } = Search;
import paginationFactory from 'react-bootstrap-table2-paginator';
import  COAMasterSlidout from "./COAMasterSlideout";
import _ from "lodash";
import { TransactionService } from "../../Common/Services/TransactionService";
import { COAService } from "../../Common/Services/COAService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown, faChevronDown } from "@fortawesome/free-solid-svg-icons";


  
class COAMaster extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
         
          htmlItem: [],
          htmlErrorItem: [],
          htmlWarningItem: [],
          searcResult: [],
          coainfo:{},
          selectedcolumn: "All",
          selectOptions: [
            { id: 'All', name: 'All'},
            { id: 'COA', name: 'COA' },
            { id: 'Name', name: 'Name' },
            { id: 'Account Type', name: 'Account Type' },
            { id: 'Main Group', name: 'Main Group' },
            { id: 'Sub Group', name: 'Sub Group' },
          ],
          sortModalOpen: false,
          sortAccountType: "",
          sortMainGroupList: [],
          sortLoading: false,
          sortSaving: false,
          selectAccountOptions: [
            // { id: 'Asset', name: 'Asset' , accid:1},
            // { id: 'Liability', name: 'Liability' , accid:2},
            // { id: 'Equity', name: 'Equity', accid:3 },
            { id: 'Revenue', name: 'Revenue', accid:4 },
            { id: 'Expense', name: 'Expense' , accid:5},
            { id: 'COGS', name: 'COGS' , accid:6}
          ],
          data:[]
        };
        
     
      }
      
      componentDidMount() {
        let requestlist = { ...this.state.requestlist };
        this.getCOAMaster(requestlist);
      }

      handleSelectedItem1 = (control: any, id: any) => {
        let searcResult1 = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.searcResult))
        );
    
        let chkisstatus = id == "Status" ? true : false;
        let chkisAccountType = id == "Account Type" ? true : false;
        let chkismaingroup = id == "Main Group" ? true : false;
        let chkisname = id == "Name" ? true : false;
        let chkissubgroup = id == "Sub Group" ? true : false;
        let chkcoa = id == "COA" ? true : false;
    
        if (id == "All") {
          chkisstatus = true;
          chkisAccountType = true;
          chkismaingroup = true;
          chkisname = true;
          chkissubgroup = true;
          chkcoa = true;
        }
    
    
        this.setState({
          searcResult: [], selectedcolumn: id, isstatus: chkisstatus, isaccountType : chkisAccountType, ismainGroup: chkismaingroup,
          isname: chkisname, issubGroup: chkissubgroup, iscoa:chkcoa
        },
          () => {
            this.setState({ searcResult: searcResult1 });    
          }
    
    
        );
    
      };
 
      getCOAMaster = (requestlist: any) => {
 //let requestlist = { ...this.state.requestlist };
    let coaListItems: any = [];

    TransactionService.GetCOA(requestlist)
      .then(async (result: any | null) => {
        if (result != null) {
         
          this.setState({ data: result });
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
      };

  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      if(row.accountID == 0){
      toast.error("Fixed COA cannot be edited.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      }else{
      this.setState({ showSlideout: true ,coainfo:row,isSpinner:false});  
      }
    },
  };
  
  showNewSlideOut = () => {
    this.setState({ showSlideout: true ,coainfo:{},isSpinner:false});  
  };

  showSortModal = () => {
    this.setState({ sortModalOpen: true, sortAccountType: "", sortMainGroupList: [] });
  };

  closeSortModal = () => {
    this.setState({ sortModalOpen: false });
  };

  saveSortedMainGroups = async () => {
    const { sortMainGroupList } = this.state;

    if (sortMainGroupList.length === 0) {
      toast.error("Please select account type and ensure there are main groups.");
      return;
    }

    this.setState({ sortSaving: true });

    try {
      await COAService.UpdateMainGrpsOrder(sortMainGroupList);
      toast.success("Main groups order updated successfully.");
      this.setState({ sortSaving: false, sortModalOpen: false });
    } catch (err: any) {
      toast.error(`Error saving order: ${err}`);
      this.setState({ sortSaving: false });
    }
  };

  loadSortMainGroups = (accountType: string) => {
    const accountOption = this.state.selectAccountOptions.find((x:any) => x.id === accountType);
    const id = accountOption ? accountOption.accid : 0;
    this.setState({ sortLoading: true, sortAccountType: accountType, sortMainGroupList: [] });

    COAService.MainGroupList({ accountid: id })
      .then((result: any | null) => {
        let sortMainGroupList: any[] = [];
        if (result != null) {
          result.forEach((element: any, index: number) => {
            sortMainGroupList.push({
              ...element,
              srno: element.srno  ?? index + 1,
            });
          });
          sortMainGroupList = sortMainGroupList.sort((a, b) => a.srno - b.srno);
        }
        this.setState({ sortMainGroupList, sortLoading: false });
      })
      .catch((err: any) => {
        this.setState({ sortLoading: false });
      });
  };

  changeSortMainGroupOrder = (index: number, direction: "up" | "down") => {
    const sortMainGroupList = [...this.state.sortMainGroupList];
    const swapIndex = direction === "up" ? index - 1 : index + 1;
    if (swapIndex < 0 || swapIndex >= sortMainGroupList.length) {
      return;
    }
    const temp = sortMainGroupList[index];
    sortMainGroupList[index] = sortMainGroupList[swapIndex];
    sortMainGroupList[swapIndex] = temp;
    sortMainGroupList[index].srno = index + 1;
    sortMainGroupList[swapIndex].srno = swapIndex + 1;
    this.setState({ sortMainGroupList });
  };

  closeSlideOut = () => {
    this.setState({ showSlideout: false, isSpinner:false, });
    let requestlist = { ...this.state.requestlist };
    this.getCOAMaster(requestlist);
};


  render() {
    const { permissions } = this.props; 
    const hasAddPermission = permissions && permissions['Chart of Accounts'] ? permissions['Chart of Accounts'].includes('Add COA') : false;
    
    const customTotal = (from, to, size) => (
      <span className="text-muted">
        Showing {from} to {to} of {size} entries
      </span>
    );
    const options = {

      showTotal: true,
      hideSizePerPage: false,
      hidePageListOnlyOnePage: true,
      paginationTotalRenderer: customTotal,
      disablePageTitle: true,
      sizePerPageList: [{
        text: '10', value: 10
      },
      {
        text: '25', value: 25
      },
      {
        text: '50', value: 50
      },

      {
        text: 'All', value: this.state.searcResult.length
      }] // A numeric array is also available. the purpose of above example is custom the text
    };
    const {
      
      showSlideout,
      
  } = this.state;

  const columns = [
    {
      searchable: this.state.iscoa,
      dataField: 'accountCode',
      text: 'COA',
      sort: true,
    },
   
    {
      searchable: this.state.isname,
      dataField: 'accountName',
      text: 'Name',
      sort: true,
    },
    {
      searchable: this.state.isaccountType,
      dataField: 'accountType',
      text: 'Account Type',
    },
    {
      searchable: this.state.ismainGroup,
      dataField: 'mainGroup',
      text: 'Main Group',
    },
    {
      searchable: this.state.issubGroup,
      dataField: 'subgroupname',
      text: 'Sub Group 1',
      formatter: (cell, row) => {
        return row.subgroupname ?  row.subgroupname:'None' ;
      }
    },
    {
      searchable: this.state.issubGroup,
      dataField: 'subgroup2name',
      text: 'Sub Group 2',
      formatter: (cell, row) => {
        return row.subgroup2name ? row.subgroup2name:'None' ;
      }
    },
    {
      searchable: this.state.issubGroup,
      dataField: 'subgroup3name',
      text: 'Sub Group 3',
      formatter: (cell, row) => {
        return row.subgroup3name ?row.subgroup3name: 'None';
      }
    },
    {
      searchable: this.state.issubGroup,
      dataField: 'rowtitlename',
      text: 'Row title',
      formatter: (cell, row) => {
        return row.rowtitlename ?row.rowtitlename: '(Match COA Name)';
      }
    },  

    {
      dataField: 'isActive',
      text: 'Status',
      sort: true,
      headerStyle: { width: '200px' },
      headerClasses: 'text-center',
      classes: 'text-center',
      
      searchable: this.state.isstatus,
      //searchable:this.state.isdueDate,
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          
          <>
         
          <EllipsisWithTooltip placement="bottom">
            
              

                <span className={ row.isActive===true ? "badge badge-pill badge-primary color-green" : "badge badge-pill badge-primary color-red"}> {row.isActive==true? "Active":"Inactive"} </span>


            </EllipsisWithTooltip>
      
      
            </>

        );
    },
    },
  ];
    return (
      <>
        <React.Fragment>



          <Container fluid className="body-sec">
            <div className="page-heading underline d-flex">

            Chart of Accounts
              <div className="action-group d-flex flex-row ml-auto">
                {hasAddPermission && <Button className="mr-2" onClick={this.showSortModal}>Setting</Button>}
                {hasAddPermission && <Button onClick={this.showNewSlideOut}>Add COA</Button>}
              </div>
            </div>

            <section className="mt-3">
            <ToolkitProvider
        keyField="id"
        data={this.state.data}
        columns={columns}

        search
      >
        {
          props => (


            <div >
              <section className="d-flex flex-wrap gap-3 pb-2">
                <div className="position-relative">
                  <SearchBar {...props.searchProps} />
                </div>

                <div className="col-12 col-md-2">
                    <SingleDropdownListWithoutSearch
                      
                      itemList={this.state.selectOptions}
                      handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                      defaultItem={this.state.selectedcolumn}
                      defaultText={"Select Filter"}
                      defaultName={this.state.selectedcolumn}
                      controlID="1"
                      id={"ddlselected"}

                    />
                </div>

              </section>
              <section className="pb-3">
                <div className="table-responsive divbottom"  >
                  <div className="ml-auto transactions-list payroll-tbl1">
                  <BootstrapTable
                    {...props.baseProps}
                    rowEvents={this.rowEvents}
                    keyField="id"
                    wrapperClasses="table-responsive fixed-header-table1"
                  //  pagination={paginationFactorry(options)}

                  />
                  </div>
                </div>
            

              </section>
            </div>

          )
        }
</ToolkitProvider>

          </section>

{(showSlideout &&

<COAMasterSlidout
closeSlideOut={this.closeSlideOut}
coainfo={this.state.coainfo}
id={this.state.id}
>
</COAMasterSlidout>)}

          <Modal show={this.state.sortModalOpen} onHide={this.closeSortModal} size="lg" centered backdrop="static" keyboard={false} scrollable>
            <Modal.Header closeButton>
              <Modal.Title>Main Groups Change Order</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group controlId="sortAccountType">
                <Form.Label>Account Type</Form.Label>
                <div style={{ position: 'relative' }}>
                  <Form.Control as="select" value={this.state.sortAccountType} onChange={(e:any) => this.loadSortMainGroups(e.target.value)}>
                    <option value="">Select account type</option>
                    {this.state.selectAccountOptions.map((option:any) => (
                      <option key={option.id} value={option.id}>{option.name}</option>
                    ))}
                  </Form.Control>
                  <FontAwesomeIcon 
                    icon={faChevronDown} 
                    size="sm" 
                    style={{ 
                      position: 'absolute', 
                      right: '12px', 
                      top: '50%', 
                      transform: 'translateY(-50%)',
                      pointerEvents: 'none',
                      color: '#6c757d'
                    }} 
                  />
                </div>
              </Form.Group>

              {this.state.sortLoading && <div className="text-center py-4"><Spinner animation="border" /></div>}

              {!this.state.sortLoading && this.state.sortAccountType && this.state.sortMainGroupList.length === 0 && (
                <div className="mt-3 text-muted">No main groups found for this account type.</div>
              )}

              {!this.state.sortLoading && this.state.sortMainGroupList.length > 0 && (
                <div className="table-responsive mt-3">
                  <table className="table table-sm table-bordered">
                    <thead>
                      <tr>
                        <th style={{ width: "80px" }}>Order</th>
                        <th>Main Group</th>
                        <th style={{ width: "140px" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.sortMainGroupList.map((item:any, index:number) => (
                        <tr key={item.mainGroupID || index}>
                          <td>{item.srno}</td>
                          <td>{item.mainGroupName}</td>
                          <td>
                            <OverlayTrigger
                              placement="bottom"
                              overlay={<Tooltip id={`sort-up-${item.mainGroupID}`}>Move up</Tooltip>}
                            >
                              <span
                                style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: 28,
                                  height: 28,
                                  marginRight: 6,
                                  borderRadius: 4,
                                  border: '1px solid #ddd',
                                  color: index === 0 ? '#999' : '#333',
                                  cursor: index === 0 ? 'not-allowed' : 'pointer',
                                  opacity: index === 0 ? 0.4 : 1,
                                  background: '#fff'
                                }}
                                onClick={() => index > 0 && this.changeSortMainGroupOrder(index, "up")}
                              >
                                <FontAwesomeIcon icon={faArrowUp} size="sm" />
                              </span>
                            </OverlayTrigger>
                            <OverlayTrigger
                              placement="bottom"
                              overlay={<Tooltip id={`sort-down-${item.mainGroupID}`}>Move down</Tooltip>}
                            >
                              <span
                                style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: 28,
                                  height: 28,
                                  borderRadius: 4,
                                  border: '1px solid #ddd',
                                  color: index === this.state.sortMainGroupList.length - 1 ? '#999' : '#333',
                                  cursor: index === this.state.sortMainGroupList.length - 1 ? 'not-allowed' : 'pointer',
                                  opacity: index === this.state.sortMainGroupList.length - 1 ? 0.4 : 1,
                                  background: '#fff'
                                }}
                                onClick={() => index < this.state.sortMainGroupList.length - 1 && this.changeSortMainGroupOrder(index, "down")}
                              >
                                <FontAwesomeIcon icon={faArrowDown} size="sm" />
                              </span>
                            </OverlayTrigger>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.closeSortModal} disabled={this.state.sortSaving}>Close</Button>
              <Button variant="primary" onClick={this.saveSortedMainGroups} disabled={this.state.sortSaving || this.state.sortMainGroupList.length === 0}>
                {this.state.sortSaving ? (
                  <>
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mr-2" />
                    Saving...
                  </>
                ) : (
                  'Save'
                )}
              </Button>
            </Modal.Footer>
          </Modal>
          </Container>
       </React.Fragment>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId
});

export default connect(mapStateToProps)(COAMaster);
